import { Playlist } from '@kinomap-dev/ng-ui-lib/lib/models/playlist.model';

export class PlaylistState {
  playlists: Playlist[] = [];
  isLoadingPlaylists: boolean = false;
  arePlaylistsComplete: boolean = false;
  homePlaylists: Playlist[] = [];
}
